import { connect } from "react-redux";

import DeviceList, {
  IDeviceListProps,
  IDeviceListActions
} from "./device-list";
import { removeDevice, approveDevice } from "../../admin.actions";

export default connect(
  (_, own: IDeviceListProps): IDeviceListProps => ({ ...own }),
  (dispatch): IDeviceListActions => ({
    approveDevice: (userId: string, deviceId: string) =>
      dispatch(approveDevice(userId, deviceId)),
    removeDevice: (userId: string, deviceId: string) =>
      dispatch(removeDevice(userId, deviceId))
  })
)(DeviceList);
